import CardThumb from '@/molecules/CardThumb';
import { ThumbnailType } from '@/molecules/thumbnails/type';

const ThumbnailItem = ({ alt, src, text }: ThumbnailType) => (
  <figure>
    <CardThumb alt={alt} className="mx-auto" imagePath={src} />
    {text && <figcaption className="text-center mt-2 text-neutral-600 md-medium">{text}</figcaption>}
  </figure>
);

export default ThumbnailItem;
